export interface SiteSettings {
  theme_color: string;
  font_family: string;
  brand_name: string;
  contact_address: string;
  contact_lat: string;
  contact_lng: string;
  contact_phone: string;
  contact_email: string;
  contact_email_secondary: string;
  business_hours: string;
  lunch_hours: string;
}

export const DEFAULT_SITE_SETTINGS: SiteSettings = {
  theme_color: 'amber',
  font_family: 'sans-serif',
  brand_name: 'COBRAND',
  contact_address: '서울시 양천구 목동동로 430',
  contact_lat: '37.5288',
  contact_lng: '126.8748',
  contact_phone: '010-4440-0702',
  contact_email: 'info@ksool.org',
  contact_email_secondary: 'info@coreasool.com',
  business_hours: '평일 09:00 - 18:00',
  lunch_hours: '12:00 - 13:00',
};
